(() => {
  'use strict';

  const PREFIX = '[FTR Rebuy Cart Suppress]';
  const REBUY_VISIBLE_CLASSES = [
    'rebuy-modal-visible',
    'rebuy-cart-visible',
    'rebuy-drawer-visible',
    'rebuy-overlay-visible'
  ];

  const REBUY_CART_SELECTORS = [
    '.rebuy-cart',
    '.rebuy-cart__flyout',
    '.rebuy-cart__background',
    '.rebuy-cart__overlay',
    '[data-rebuy-cart]',
    '[data-rebuy-cart-flyout]'
  ];

  function stripRebuyVisibilityClasses() {
    [document.documentElement, document.body].forEach((node) => {
      if (!node) return;
      REBUY_VISIBLE_CLASSES.forEach((className) => node.classList.remove(className));
    });
  }

  function removeExistingRebuyCartDom() {
    document.querySelectorAll(REBUY_CART_SELECTORS.join(',')).forEach((node) => {
      if (node.closest?.('#ftr-cart-drawer')) return;
      node.remove();
    });
  }

  function setCustomCartActive(active) {
    [document.documentElement, document.body].forEach((node) => {
      if (!node) return;
      node.classList.toggle('ftr-custom-cart-active', !!active);
    });
  }

  function isCustomDrawerOpen() {
    return !!document.getElementById('ftr-cart-drawer')?.classList.contains('is-open');
  }

  function cleanupRebuy({ removeDom = false } = {}) {
    stripRebuyVisibilityClasses();
    if (removeDom) removeExistingRebuyCartDom();

    if (!isCustomDrawerOpen()) {
      setCustomCartActive(false);
    }
  }

  function wrapCustomCartApi() {
    const cart = window.FTRCart;
    if (!cart || cart.__ftrRebuySuppressed) return !!cart;

    const originalOpen = typeof cart.open === 'function' ? cart.open.bind(cart) : null;
    const originalClose = typeof cart.close === 'function' ? cart.close.bind(cart) : null;

    if (originalOpen) {
      cart.open = function (...args) {
        cleanupRebuy({ removeDom: true });
        setCustomCartActive(true);

        const result = originalOpen(...args);

        requestAnimationFrame(() => {
          stripRebuyVisibilityClasses();
          setCustomCartActive(true);
        });

        return result;
      };
    }

    if (originalClose) {
      cart.close = function (...args) {
        const result = originalClose(...args);

        stripRebuyVisibilityClasses();
        setCustomCartActive(false);
        document.body.style.overflow = '';

        return result;
      };
    }

    cart.__ftrRebuySuppressed = true;
    return true;
  }

  function bindCleanupEvents() {
    document.addEventListener('ftr:cart:added', () => {
      cleanupRebuy({ removeDom: true });
      if (isCustomDrawerOpen()) setCustomCartActive(true);
    });

    document.addEventListener('click', (event) => {
      if (
        event.target.closest('#ftr-close-btn') ||
        event.target.closest('#ftr-cart-drawer-overlay')
      ) {
        requestAnimationFrame(() => {
          stripRebuyVisibilityClasses();
          setCustomCartActive(false);
          document.body.style.overflow = '';
        });
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      requestAnimationFrame(() => {
        if (!isCustomDrawerOpen()) {
          stripRebuyVisibilityClasses();
          setCustomCartActive(false);
          document.body.style.overflow = '';
        }
      });
    }, true);
  }

  function init() {
    cleanupRebuy({ removeDom: true });
    bindCleanupEvents();

    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (wrapCustomCartApi() || attempts >= 40) {
        clearInterval(timer);
      }
    }, 50);

    window.setTimeout(() => cleanupRebuy({ removeDom: true }), 500);
    window.setTimeout(() => cleanupRebuy({ removeDom: true }), 1500);

    console.log(PREFIX, 'Rebuy cart suppression enabled without mutation observer.');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
